export interface SpinnerProps {
	size?: "sm" | "md" | "lg";
	className?: string;
}

export const Spinner = ({ size = "md", className = "" }: SpinnerProps) => {
	const sizeClasses = {
		sm: "w-4 h-4 border-2",
		md: "w-6 h-6 border-2",
		lg: "w-8 h-8 border-3",
	};

	return (
		<div
			className={`${sizeClasses[size]} border-current border-t-transparent rounded-full animate-spin ${className}`}
			style={{
				animation: "spin 0.6s linear infinite",
			}}
		/>
	);
};
